import {
  Component,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-select-multiple-input",
  templateUrl: "./select-multiple-input.component.html",
  styleUrls: ["./select-multiple-input.component.css"],
})
export class SelectMultipleInputComponent {
  @Input() options: { value: string; display: string }[] = [];
  @Input() value: { value: string; display: string }[] = [];
  @Output() dataOutput = new EventEmitter<
    { value: string; display: string }[]
  >();

  onSelectionChange(event: { value: string; display: string }[]) {
    this.value = event;
    this.dataOutput.emit(this.value);
  }

  compareFn(
    option1: { value: string; display: string },
    option2: { value: string; display: string },
  ): boolean {
    return option1 && option2
      ? option1.value === option2.value
      : option1 === option2;
  }
}
